import React, { useState } from "react";

import { EmailForm, LoginForm, Message } from "../components";

import "../assets/css/dash.css";
import "../assets/css/login-modern.css";

export const LogIn = () => {
  const [recoverPassword, setRecoverPassword] = useState(false);

  const handleChangeToLogIn = () => setRecoverPassword(false);
  const handleChangeToRecoverPassword = () => setRecoverPassword(true);

  return (
    <div className="ps-login-page">
      <Message />

      <div className="ps-login-container">
        {recoverPassword ? (
          <EmailForm
            handleChangeToLogIn={handleChangeToLogIn}
          />
        ) : (
          <LoginForm
            handleChangeToRecoverPassword={
              handleChangeToRecoverPassword
            }
          />
        )}
      </div>
    </div>
  );
};
